import { render, staticRenderFns } from "./AdvertiserPanelBonusAds.vue?vue&type=template&id=018030ab&"
import script from "./AdvertiserPanelBonusAds.vue?vue&type=script&lang=js&"
export * from "./AdvertiserPanelBonusAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports